import { useQuery } from "@tanstack/react-query";
import { orderService, type OrderEstimateParams, type OrderPreviewParams } from "@/services/orderService";

/**
 * Backend v2.1 (Sprint 4.5) `POST /orders/preview`/`POST /orders/estimate`
 * - both strictly read-only (never create an order), so they are modeled
 * as queries (auto-refetch when the Order Ticket's own values change)
 * rather than mutations, matching every other instrument-selection-driven
 * hook in this codebase (`useQuote`, `useInstrumentSearch`). `enabled` is
 * derived from whether a request is present, the same convention
 * `useQuote`'s `Boolean(instrumentToken)` already uses.
 */
export function useOrderRiskPreview(request: OrderPreviewParams | null) {
  return useQuery({
    queryKey: ["orders", "preview", request],
    queryFn: () => orderService.previewOrder(request as OrderPreviewParams),
    enabled: Boolean(request),
  });
}

export function useOrderEstimate(request: OrderEstimateParams | null) {
  return useQuery({
    queryKey: ["orders", "estimate", request],
    queryFn: () => orderService.estimateOrder(request as OrderEstimateParams),
    enabled: Boolean(request),
  });
}
